type Notification = {
  createdDate: string;
  data: any;
  type: string;
  uuid: string;
  isRead: boolean;
};

export type { Notification };
